import type { Currency } from "../Currency.js";
import type { Locale } from "../Locale.js";

export function formatPrice(price: number | string, locale: Locale, withFraction: boolean, currency: Currency): string {
	const format = new Intl.NumberFormat(locale, {
		style: "currency",
		currency,
		minimumFractionDigits: withFraction ? 2 : 0,
		maximumFractionDigits: 2,
	});
	return format.format(typeof price === "string" ? parseFloat(price) : price);
}
